import { useEffect, useMemo } from 'react';

import { ControlPosition, useControl } from 'shared/map-exports';
import {
  BaseMapboxGLController,
  BaseMapboxGLControllerProps,
  ThemeMode,
} from 'features/mapping/components/controls/BaseMapboxGLController';
import { useColorScheme } from 'hooks/useColorScheme';

export const useMapGLController = <T>(
  props: T & { position?: ControlPosition; forcedThemeMode?: ThemeMode },
  ControllerClass: new (
    props: T & BaseMapboxGLControllerProps,
  ) => BaseMapboxGLController<T & BaseMapboxGLControllerProps>,
): void => {
  const { position, forcedThemeMode } = props;
  const { mode: themeMode } = useColorScheme();

  const controllerProps = useMemo(
    () =>
      ({
        ...props,
        themeMode,
        forcedThemeMode,
      }) as T & BaseMapboxGLControllerProps,
    [props, themeMode, forcedThemeMode],
  );

  const controller = useControl(
    // @ts-ignore - https://github.com/visgl/deck.gl/issues/9211
    () => new ControllerClass(controllerProps),
    {
      position,
    },
  ) as BaseMapboxGLController<T & BaseMapboxGLControllerProps>;

  controller.update(controllerProps);
  useEffect(() => controller.render(), [controller, controllerProps]);
};
